import React from 'react';
import { Pagination } from '@mui/material';
import { Table } from '@tanstack/react-table';
import styles from './ProductCostsFooter.module.scss';


type Props = {
    table: Table<any>,
}


const ProductCostsFooter = ({ table }: Props) => {



    return (
        <div className={styles.footerContainer}>
            <Pagination count={table?.getState()['pagination']['pageCount']} page={table?.getState().pagination?.pageIndex + 1} shape="rounded" onChange={(e, value) => {
                table.setPageIndex(value - 1);
            }}
                sx={{
                    '& .MuiButtonBase-root': {
                        fontFamily: "Quicksand",
                        fontSize: "0.75rem",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "1rem",
                    },
                    '.MuiPaginationItem-root': {
                        backgroundColor: "#fff",
                        borderRadius: "0.5rem",
                        color: '#212121',
                        '&: hover': {
                            backgroundColor: "#E8E7EA"
                        }
                    },
                    '& .MuiPaginationItem-ellipsis': {
                        '&: hover': {
                            backgroundColor: "transparent"
                        }
                    },
                    '& .MuiPaginationItem-previousNext': {
                        backgroundColor: "#F0EFF4",
                        borderRadius: "0.5rem",
                        color: "#212121",
                        '&: hover': {
                            backgroundColor: "#E8E7EA"
                        }
                    },
                    '& .Mui-selected': { // This targets the selected page number
                        backgroundColor: "#100828 !important",
                        borderRadius: "0.5rem",
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: "#100828",
                        },
                    }
                }}
            />
        </div>
    );
}

export default ProductCostsFooter;